<template>
  <div class="tw-w-full">
    <div ref="target" class="tw-flex tw-w-full tw-justify-between">
      <div class="tw-flex">
        <tooltip-hover
          v-for="(option, index) in options"
          :key="index"
          :text="option.tooltip"
        >
          <component
            :is="option.to ? 'base-link' : 'button'"
            :to="option.to || null"
            :link-primary="false"
            :target="option.to && option.external ? '_blank' : null"
            class="game-button-radius tw-group tw-py-4 tw-px-2 xs:tw-px-4 tw-flex tw-justify-center tw-items-center tw-relative tw-outline-none tw-text-h6 tw-leading-tight tw-whitespace-nowrap mod-button-transition tw-group"
            :class="[
              Classes.TAB,
              option.disabled
                ? 'tw-cursor-not-allowed'
                : 'hover:game-active-button-color-hover',
              {
                active: isActive(index),
                'tw-space-x-1': !option.to,
              },
            ]"
            :tabindex="isActive(index) ? '-1' : '0'"
            @click="!option.disabled && updateTab($event, option)"
          >
            <font-awesome-icon
              v-if="!option.to && option.icon"
              class="tw-mr-2"
              :icon="option.icon"
            />
            <span
              class="tw-font-medium tw-transition-all"
              :class="[
                linkClass(index),
                { 'group-hover:game-active-text-hover': !option.disabled },
              ]"
            >
              {{ option.text }}
              <font-awesome-icon
                v-if="option.external"
                icon="external-link-alt"
                size="xs"
              />
            </span>
            <base-badge v-if="option.count" :text="option.count" />
            <div
              class="tw-absolute tw-inset-x-0 tw-h-0.5 game-primary-button-color -tw-bottom-0.5"
              :class="isActive(index) ? 'tw-opacity-100' : 'tw-opacity-0'"
              style="margin-left: 0px"
            />
          </component>
        </tooltip-hover>
        <slot name="after" />
      </div>
      <slot />
    </div>
    <div class="tw-h-0.5 game-tile-background-color" />
  </div>
</template>

<script>
import TooltipHover from '@components/Message/TooltipHover.vue'
import { watchEffect, toRefs, ref } from 'vue'
import Classes from '@shared/js/config/css.js'

export default {
  components: {
    TooltipHover,
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { modelValue, options } = toRefs(props)
    const target = ref(null)

    function isActive(index) {
      return (
        options.value.findIndex((o) => o.value === modelValue.value) === index
      )
    }

    function linkClass(index) {
      if (isActive(index)) {
        return ''
      }
      return options.value[index].disabled
        ? 'tw-opacity-50'
        : 'tw-opacity-75 group-hover:tw-opacity-100'
    }

    function updateTab(e, option) {
      emit('input', e, option.value)
    }

    watchEffect(() => {
      if (target.value && options.value?.length) {
        for (let i in options.value) {
          if (isActive(i)) {
            target.value.children[i]?.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center',
            })
            return
          }
        }
      }
    })

    return {
      linkClass,
      updateTab,
      isActive,
      Classes,
      target,
    }
  },
}
</script>
